(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oshan-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.matches('.osh-index__item[open]')) return;
    const library = item.closest('.osh-index__library');
    if (!library) return;
    library.querySelectorAll('.osh-index__item[open]').forEach((other) => {
      if (other !== item) other.removeAttribute('open');
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oshan-scent-library"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.matches('.osh-index__item[open]')) return;
    const library = item.closest('.osh-index__library');
    if (!library) return;
    library.querySelectorAll('.osh-index__item[open]').forEach((other) => {
      if (other !== item) other.removeAttribute('open');
    });
  }, true);

  } catch(e) { console.error(e); }
})();
})();
